import { ReactStateType } from "@xnav/types/src/frontend"
import { createContext } from "react"

export type DraggingContextType = {
		id: string,
		data: Object,
		onDragEnd: () => void
}

export const DraggingContext = createContext([undefined, () => { }] as ReactStateType<DraggingContextType | undefined>)
